const transformNodeText = (text) => text.toLowerCase().trim().replace(/[\s\-\.]/g, '_');

const getCompanyFromNode = (node) => {
  var companyNode = node.querySelector(".project-overlay__company")

  return transformNodeText(companyNode.innerHTML);
};

const convertLanguage = {
  'ca_en': 'en_CA',
  'ko': 'ko_KR',
  'fi': 'fi_FI',
  'zh': 'zh_CH',
  'au': 'en_AU',
  'gb': 'en_GB',
  'la_es': 'es_LATAM',
  'ca_fr': 'fr_CA',
};

const getVideoPayload = (node, currentPage) => {
  const lang = convertLanguage[currentPage];
  const current_page = getCurrentPage(currentPage);
  const feature = node.getAttribute('data-feature');

  return lang ?
    { region: lang, feature } :
    { current_page, feature };
};

const getDownloadPayload = (node, currentPage) => {
  const lang = convertLanguage[currentPage];
  const current_page = getCurrentPage(currentPage);
  const platform = node.getAttribute('data-platform');

  return lang ?
    { region: lang, platform } :
    { current_page, platform };
};

const getCurrentPage = pagename => {
  const regional = isRegionalPage(pagename);

  if (pagename.match(/\./)) return pagename.split('.')[1];

  return regional || pagename;
};

const isRegionalPage = (currentPage) => convertLanguage[currentPage];

const getHref= (node) => transformNodeText(node.getAttribute('href'));

const getRegionalHeaderLinkName = (node) => {
  const linkName = node.getAttribute('data-link-name');
  if (linkName) return linkName;

  const splitHref = node.href.split('/');
  const clickedLink = splitHref[splitHref.length - 1].replace('-', '_');

  return clickedLink === '' ? "en_US" : convertLanguage[clickedLink];
};

const featureExploreEventName = (pagename) => {
  const regional = isRegionalPage(pagename);

  return regional ? 'splash.regional.feature_explore.click' : 'splash.feature_explore.click'
};

const downloadEventName = (pagename) => {
  const regional = isRegionalPage(pagename);

  return regional ? 'splash.regional.download.click' : 'splash.product.download.click'
}

module.exports = {
  transformNodeText,
  getCompanyFromNode,
  getHref,
  getCurrentPage,
  getRegionalHeaderLinkName,
  convertLanguage,
  getVideoPayload,
  getDownloadPayload,
  featureExploreEventName,
  downloadEventName,
}



// WEBPACK FOOTER //
// ./src/pages/helpers/analytics.js